var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"class_body"},[_c('class-body-text',{attrs:{"name":this.name}}),_c('class-body-table',{ref:"childTable",attrs:{"name":this.name}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }